export default "__VITE_ASSET__46373f0b__"